import React from 'react';

import { Link } from "react-router-dom";
const Header = ({ onBackClick, showBackButton }) => {
	return (
		<header className="app-header">
			<div className="header-content">
				{showBackButton && (
					<Link to={"/"} style={{textDecorationColor: "transparent"}}>
						<button className="back-button">
							&larr; Back to Projects
						</button>
					</Link> 
				)}
				<h1>Comet Technologies</h1>
				<p className="tagline">You need it, I'll build it</p>
			</div>
		</header>
	);
};

export default Header;